import React, { useState, useEffect, useRef, useContext } from 'react';
import './StyledButton.scss';
import { AppContext } from '../../Context';

export default function StyledButton(props) {
    const [isActive, setActive] = useState(false);
        const inputRef = useRef(null);
        const {dealerPoi, setDealerPoi,stateData} = useContext(AppContext);
   
    useEffect(()=>{
        // setActive(false);
        // setDealerPoi(false);
        try {
           props.callBack(props.styleCode, props.text, false);
           setActive(false);
           setDealerPoi(false);
        } catch (error) {
        }
    },[stateData.selected.State, stateData.selected.District, stateData.selected.Sub_District,stateData.mapObject])

    const callBack = () => {
        // console.log("props", props)
        if (props.text !== "Dealer") {
            // console.log("props.name", props.text)
            props.callBack(props.styleCode, props.text, !isActive);
            setActive(!isActive);
        }
        else {
            setDealerPoi(!dealerPoi)
            // console.log('dealer poi - - ',dealerPoi);
        }
    }
    
        useEffect(() => {
            inputRef.current?.style.setProperty("--inactive_color", props.color ? props.color : "#171b8f");
        }, [isActive,dealerPoi,props.color]);


    if (props.styleCode === "poi") {
        if (props.text != "Dealer") {
            return (
                <button id={props.text} ref={inputRef} className={isActive ? "btn active" : "btn"} onClick={() => {
                    callBack();
                }} active={isActive.toString()}>
                    <div className='sidebar-btn-content'>
                        {props.icon && <div className='icon-div'><i className={props?.icon}></i></div>}
                        {props.img && <div className='icon-div'><img className="img-icon2" src={props.img} alt="road-icon" /></div>}
                        {/* <div className='vsep'></div> */}
                        <div className='sidebar-btn-text'>{props.text}</div>
                    </div>
                </button>
            //         <button id={props.text} ref={inputRef} onClick={() => { callBack()}} active={dealerPoi.toString()}>
            //           <div className="grid-item">
            //             <div className="logo-container">
            //               <img
            //                 src="rec5.png"
            //              alt="logo"
            //              className="logo w-10 h-10 mr-2"
            //            />
            //            <img src="p1.png" alt="image" className="inner-image " />
            //            {/* <i className={props.icon} style={{ 'padding': '2px' }}></i> */}
            //          </div>
            //          <span>{props.text}</span>{" "}
            //     </div>
            //   </button>
            );
        }

        else {
            return (
                <button id={props.text} ref={inputRef} className={dealerPoi ? "btn active" : "btn"} onClick={() => {
                    callBack()
                }} active={dealerPoi.toString()}>
                    <div className='sidebar-btn-content'>
                        <div className='icon-div'><i className={props.icon}></i></div>
                        {/* <div className='vsep'></div> */}
                        <div className='sidebar-btn-text'>{props.text}</div>
                    </div>
                </button>
            );
        }
    } else if (props.styleCode === "road") {
        return (
            <button className={isActive ? "btn active road-btn" : "btn road-btn"} ref={inputRef} onClick={() => {
                callBack();
            }} active={isActive.toString()}>
                <div className='sidebar-btn-content'>
                        <div className='icon-div'><img className="img-icon" src={props.img} alt="road-icon" /></div>
                        {/* <div className='vsep'></div> */}
                        <div className='sidebar-btn-text'>{props.text}</div>
                </div>
            </button>
        );
    }
    }
   
        
   
// import React, { useState ,useEffect,useMemo,useContext,useRef} from 'react';
// import './StyledButton.scss';
// import { AppContext } from '../../Context';


// export default function StyledButton(props){

//     const [isActive,setActive] = useState(false);
  
//     const inputRef = useRef(null);
//     const {stateData} = useContext(AppContext);
//     const [selected,setSelected] = useState({'State':'','District':'','Sub_District':'','Village':''});


//     const callBack = () => {
//         props.callBack(props.styleCode,props.text,!isActive);
//         setActive(!isActive);
//     }

//     useEffect(()=>{


//         if(isActive && stateData.selected !== selected){
//             let currSelected = stateData.selected;
//             // console.log('stateData.sel->',stateData.selected,'selected->',selected);

//             if((!currSelected.Sub_District && selected.Sub_District) || 
//             (!currSelected.Village && selected.Village) ||
//             (!currSelected.District && selected.District)){
//                 setActive(false);
                
//             }
//             //props.callBack(props.styleCode,props.text,false);
//             setSelected(stateData.selected);
            
//         }
        
//      },[stateData.selected]);

//     useEffect(() => {
//         inputRef.current?.style.setProperty("--inactive_color", props.color ? props.color : "#171b8f");
//       }, [isActive,props.color]);
//     if(props.styleCode === "poi"){
//     return(
//         <button id={props.text} ref={inputRef} className={isActive? "btn active" : "btn"} onClick={()=>{
//             callBack();
//         }} active={isActive.toString()}>
//             <i className={props.icon} style={{'padding':'2px'}}></i>
//             {props.text}</button>
//     );
//     }else if(props.styleCode === "road"){
//         return(
//             <button className={isActive? "btn active" : "btn"} ref={inputRef} onClick={()=>{
//                 callBack();
//             }} active={isActive.toString()}>
//                 <img className="img-icon" src={props.img} alt="road-icon"/>
//                 {props.text}</button>
//         );
//     }
// }